import { request } from "@prismicio/editor-support/Http"
import { z } from "zod"

import { env } from "../env"

interface EmailLoginParams {
  email: string
  password: string
}

export function emailLogin(params: EmailLoginParams) {
  const { email, password } = params

  return request(new URL("login", env.AUTHENTICATION_SERVER_BASE_URL), {
    method: "POST",
    body: { email, password },
    okType: z.string()
  })
}
